<template>
  <iframe
    :src="src"
    ref="contract"
    scrolling="auto"
    frameborder="0"
    style="width: 100%;height: 850px;"
  ></iframe>
</template>

<script>
export default {
  name: 'iframe',
  props: {
    src: { type: String, default: '' }
  }
};
</script>

<style scoped></style>
